
<div style="margin-top: 50%; margin-left: 30%">
    <h1 style="color: #9b7544">Please wait...</h1>
    </div>
    <div style="margin-left: 40%">
    <img src="assets/images/load.gif" width="100" >
    </div>